<template>
  <v-dialog v-model="dialog" content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card>
      <v-card-title class="headline">Delete Confirmation</v-card-title>
      <v-card-text>
        <v-container>
          <alert-message />
          Are you sure will delete this time clock "{{ item.name }}"?
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeDelete">Cancel</v-btn>
        <v-btn class="error" text @click="deleteItemConfirm" :loading="loading"
          >Delete
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import AlertMessage from 'src/components/AlertMessage.vue';

export default {
  components: { AlertMessage },
  props: {
    item: Object,
    show: [Boolean, String],
  },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      timeclock: (state) => state.timeclock,
      alert: (state) => state.alert,
    }),
  },
  watch: {
    show(n, o) {
      this.$store.dispatch('alert/clear');
      if (n && !o) {
        this.dialog = true;
      }
    },
  },
  methods: {
    ...mapActions("timeclock", ["delete"]),
    closeDelete() {
      this.dialog = false;
      this.$emit("onClosed");
    },
    async deleteItemConfirm() {
      this.loading = true;
      let item = {
        ...this.item,
        name: this.item.name || this.item.Name,
        id: this.item.id || this.item.Id
      }
      await this.delete(item);
      if (!this.timeclock.status.error) {
        this.closeDelete();
        this.$emit("onSucceded");
      }
      this.loading = false;
    },
  },
};
</script>